import { productos, type Product } from '@/data/products';

export const GA_MEASUREMENT_ID = 'G-HKZRZC1ZWG';
const CURRENCY = 'PEN';

declare global {
  interface Window {
    gtag?: (...args: unknown[]) => void;
  }
}

export interface AnalyticsItem {
  item_id: string;
  item_name: string;
  item_category?: string;
  item_variant?: string;
  item_list_name?: string;
  price: number;
  quantity: number;
  index?: number;
}

interface CartLikeItem {
  productId: string;
  name: string;
  presentation: string;
  unitPrice: number;
  quantity: number;
}

export function trackEvent(name: string, params: Record<string, unknown> = {}) {
  window.gtag?.('event', name, {
    send_to: GA_MEASUREMENT_ID,
    ...params,
  });
}

/** Clic de contacto (no es un pedido). */
export function trackWhatsappClick(origen: string) {
  trackEvent('whatsapp_click', { origen, method: 'whatsapp' });
}

export function productToAnalytics(
  product: Product,
  presentation: string,
  price: number,
  quantity = 1,
): AnalyticsItem {
  return {
    item_id: product.id,
    item_name: product.name,
    item_category: product.categoria,
    item_variant: presentation,
    price,
    quantity,
  };
}

export function cartItemToAnalytics(item: CartLikeItem, quantity = item.quantity): AnalyticsItem {
  const product = productos.find((entry) => entry.id === item.productId);
  return {
    item_id: item.productId,
    item_name: item.name,
    item_category: product?.categoria,
    item_variant: item.presentation,
    price: item.unitPrice,
    quantity,
  };
}

/** Eventos de comercio de GA4, en soles. */
export function trackEcommerce(
  name:
    | 'view_item_list'
    | 'select_item'
    | 'view_item'
    | 'add_to_cart'
    | 'remove_from_cart'
    | 'begin_checkout'
    | 'generate_lead',
  items: AnalyticsItem[],
  extra: Record<string, unknown> = {},
) {
  const value = items.reduce((sum, item) => sum + item.price * item.quantity, 0);
  trackEvent(name, {
    currency: CURRENCY,
    value: Math.round(value * 100) / 100,
    items,
    ...extra,
  });
}
